import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
// import Select2 from 'react-select2-wrapper';
import Select2 from 'react-select2-wrapper';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withTeam from '../../common/withTeam';
import withOnline from '../../common/withOnline';
import withUser from '../../common/withUser';
import withTableName from '../../common/withTableName';
import {
  // getCaseSetAggregate,
  getCaseSetAggregateV3,
} from '../../utils/utils';
import {
  getCustomerNoByName,
  getTableCaseByCaseId
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import withAggregatePlan from '../../common/withAggregatePlan';
import SingleAggrete from '../../components/Aggregate/SingleAggrete';
import TeamAggrete from '../../components/Aggregate/TeamAggrete';

class AggregatePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerNo: '',
      CustomerName: '',
      totalSets: [],
      selectedDate: null,
      hospitalSets: [],
      hospitalSetsByType: [],
      caseType: 'all',
      allHospitalSets: [],
      allAggregateData: [],
    };
    this.onlineAlertModal = null;
  }

  _getAggregatePlan = async () => {
    try {
      const {
        params: { id }, tableName, notify, setLoader, online
      } = this.props;
      const { customerNo } = this.state;
      const caseDetails = await getTableCaseByCaseId(id, tableName);
      const customerNumber = customerNo === '' ? caseDetails.CustomerNo : customerNo;
      if (customerNo === '') {
        this.setState({ CustomerName: caseDetails.CustomerName });
      }
      if (online) {
        this.setState({ selectedDate: caseDetails.CaseDate });
        setLoader(true);
        // getCaseSetAggregate(caseDetails.CaseDate, customerNumber).then((resp) => {
        //   const { status, message, data } = resp;
        //   if (status) {
        //     if (data) {
        //       const filteredTotalSeta = data.totals.filter((obj) => obj.Cases !== '0');
        //       this.setState({
        //         totalSets: filteredTotalSeta,
        //         hospitalSets: data.hospital_sets,
        //         allHospitalSets: data.hospital_sets,
        //       }, async () => {
        //         await this._getHospitalSets();
        //         setLoader(false);
        //       });
        //     }
        //     setLoader(false);
        //   } else {
        //     notify({ type: 'error', message });
        //     setLoader(false);
        //   }
        // });

        this.setState({
          totalSets: [],
          hospitalSets: [],
          hospitalSetsByType: [],
          caseType: 'all',
          allHospitalSets: [],
          allAggregateData: [],
        });

        await getCaseSetAggregateV3(caseDetails.CaseDate, customerNumber).then((resp) => {
          // console.log('v3', resp);
          const { status, message, data } = resp;
          if (status) {
            if (data) {
              this.setState({
                allAggregateData: data,
              });

              if (data.length === 1) {
                const filteredTotalSeta = data[0].totals.filter((obj) => obj.Cases !== '0');
                this.setState({
                  totalSets: filteredTotalSeta,
                  hospitalSets: data[0].hospital_sets,
                  allHospitalSets: data[0].hospital_sets,
                }, async () => {
                  await this._getHospitalSets();
                  setLoader(false);
                });
              }
            }
            setLoader(false);
          } else {
            notify({ type: 'error', message });
            setLoader(false);
          }
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view aggregate plan.' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getHospitalSets = () => {
    const { hospitalSets } = this.state;
    const result = [...hospitalSets.reduce((mp, o) => {
      if (!mp.has(o.SetName)) mp.set(o.SetName, { ...o, count: 0 });
      mp.get(o.SetName).count++;
      return mp;
    }, new Map()).values()];
    const hospitalSetsRes = result.filter((obj) => obj.DeviceType !== null);
    const hospitalSetsByType = _.groupBy(hospitalSetsRes, 'DeviceType');
    const sorted = Object.keys(hospitalSetsByType)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = hospitalSetsByType[key];

        return accumulator;
      }, {});

    this.setState({ hospitalSetsByType: sorted });
  }

  _primaryLabels = (planData) => {
    let primaryLabel = '';
    if (parseInt(planData.PrimaryLeftCount, 10) > 0
      && parseInt(planData.PrimaryRightCount, 10) > 0
      && parseInt(planData.PrimaryBilateralCount, 10) > 0) {
      primaryLabel = ` (L${planData.PrimaryLeftCount}/R${planData.PrimaryRightCount}/B${planData.PrimaryBilateralCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) > 0
      && parseInt(planData.PrimaryRightCount, 10) === 0
      && parseInt(planData.PrimaryBilateralCount, 10) === 0) {
      primaryLabel = ` (L${planData.PrimaryLeftCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) === 0 && planData.PrimaryRightCount > 0
      && parseInt(planData.PrimaryBilateralCount, 10) === 0) {
      primaryLabel = ` (R${planData.PrimaryRightCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) === 0
      && parseInt(planData.PrimaryRightCount, 10) === 0
      && parseInt(planData.PrimaryBilateralCount, 10) > 0) {
      primaryLabel = ` (B${planData.PrimaryBilateralCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) > 0
      && parseInt(planData.PrimaryRightCount, 10) > 0
      && parseInt(planData.PrimaryBilateralCount, 10) === 0) {
      primaryLabel = ` (L${planData.PrimaryLeftCount}/R${planData.PrimaryRightCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) > 0
      && parseInt(planData.PrimaryRightCount, 10) === 0
      && parseInt(planData.PrimaryBilateralCount, 10) > 0) {
      primaryLabel = ` (L${planData.PrimaryLeftCount}/B${planData.PrimaryBilateralCount})`;
    } else if (parseInt(planData.PrimaryLeftCount, 10) === 0
      && parseInt(planData.PrimaryRightCount, 10) > 0
      && parseInt(planData.PrimaryBilateralCount, 10) > 0) {
      primaryLabel = ` (R${planData.PrimaryRightCount}/B${planData.PrimaryBilateralCount})`;
    }

    return primaryLabel;
  }

  _revisionLabels = (planData) => {
    let primaryLabel = '';
    if (parseInt(planData.RevisionLeftCount, 10) > 0
      && parseInt(planData.RevisionRightCount, 10) > 0
      && parseInt(planData.RevisionBilateralCount, 10) > 0) {
      primaryLabel = ` (L${planData.RevisionLeftCount}/R${planData.RevisionRightCount}/B${planData.RevisionBilateralCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) > 0
      && parseInt(planData.RevisionRightCount, 10) === 0
      && parseInt(planData.RevisionBilateralCount, 10) === 0) {
      primaryLabel = ` (L${planData.RevisionLeftCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) === 0 && planData.RevisionRightCount > 0
      && parseInt(planData.RevisionBilateralCount, 10) === 0) {
      primaryLabel = ` (R${planData.RevisionRightCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) === 0
      && parseInt(planData.RevisionRightCount, 10) === 0
      && parseInt(planData.RevisionBilateralCount, 10) > 0) {
      primaryLabel = ` (B${planData.RevisionBilateralCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) > 0
      && parseInt(planData.RevisionRightCount, 10) > 0
      && parseInt(planData.RevisionBilateralCount, 10) === 0) {
      primaryLabel = ` (L${planData.RevisionLeftCount}/R${planData.RevisionRightCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) > 0
      && parseInt(planData.RevisionRightCount, 10) === 0
      && parseInt(planData.RevisionBilateralCount, 10) > 0) {
      primaryLabel = ` (L${planData.RevisionLeftCount}/B${planData.RevisionBilateralCount})`;
    } else if (parseInt(planData.RevisionLeftCount, 10) === 0
      && parseInt(planData.RevisionRightCount, 10) > 0
      && parseInt(planData.RevisionBilateralCount, 10) > 0) {
      primaryLabel = ` (R${planData.RevisionRightCount}/B${planData.RevisionBilateralCount})`;
    }
    return primaryLabel;
  }

  _onChangeCaseDetail = async (custno) => {
    try {
      if (custno !== '' && custno !== null) {
        const {
          params: online
        } = this.props;
        const customerNoRes = await getCustomerNoByName(custno);
        if (online) {
          this.setState({
            CustomerName: custno,
            customerNo: customerNoRes.CustomerNo,
          }, async () => {
            await this._getAggregatePlan();
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _caseType = (type) => {
    const { allHospitalSets } = this.state;
    // const filter = allHospitalSets.filter((d) => (d.CaseType === type));
    const filter = allHospitalSets.filter((d) => (d.CaseType.indexOf(type) > -1));
    if (type === 'all') {
      this.setState({
        caseType: type, hospitalSets: allHospitalSets
      }, async () => {
        await this._getHospitalSets();
      });
    } else {
      this.setState({
        caseType: type, hospitalSets: filter
      }, async () => {
        await this._getHospitalSets();
      });
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getAggregatePlan();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack, aggregatePlan } = this.props;
    const {
      totalSets, selectedDate, CustomerName, hospitalSetsByType, caseType, allAggregateData
    } = this.state;
    const dateFormat = 'MMM DD, YYYY';

    return (
      <section className="list-section resizer-class">
        <Header
          title="Aggregate Plan"
          goBack={() => onGoBack(goBack)}
        />
        <section className="case-details-section">
          <div className="container">
            <div className="row gx-2">
              {
                (aggregatePlan !== '')
                  ? (
                    <div className="col-12 case-data">
                      <Select2
                        style={{ width: '100%' }}
                        className="form-control right-arrow"
                        data={aggregatePlan.map((value) => value.customer)}
                        onChange={({ target: { value } }) => {
                          this._onChangeCaseDetail(value);
                        }}
                        value={CustomerName}
                        options={{ placeholder: 'Hospital' }}
                      />
                    </div>
                  ) : ''
              }
              <p className="date pt-2">
                {selectedDate !== null ? moment(selectedDate, ['YYYY-MM-DD']).format(dateFormat) : ''}
              </p>
            </div>

            {
              allAggregateData.length > 0 && (
                allAggregateData.length === 1
                  ? (
                    <SingleAggrete
                      totalSets={totalSets}
                      hospitalSetsByType={hospitalSetsByType}
                      caseType={caseType}
                      setPrimaryLabels={(data) => this._primaryLabels(data)}
                      setRevisionLabels={(data) => this._revisionLabels(data)}
                      setCaseType={(data) => this._caseType(data)}
                    />
                  )
                  : (
                    <TeamAggrete
                      allAggregateData={allAggregateData}
                      setPrimaryLabels={(data) => this._primaryLabels(data)}
                      setRevisionLabels={(data) => this._revisionLabels(data)}
                    />
                  )
              )
            }

          </div>
        </section>
      </section>
    );
  }
}

export default withTableName(
  withAggregatePlan(
    withTeam(
      withNotify(
        withOnline(
          withLoader(
            withUser(
              withGoBack(
                AggregatePlan
              )
            )
          )
        )
      )
    )
  )
);
